import type { PropertyConditions } from "@rebasepro/types";

/**
 * Suppress a relation's *form field* without touching its entity tab.
 *
 * A relation with `cardinality: "many"` is surfaced twice by the admin. Once
 * correctly, as a tab: `getEntityChildViews` promotes every many-relation to an
 * entity child view. And once wrongly, as a field inside the form — because the
 * only way to declare a relation is to put it in `properties`, and the form
 * renders everything it finds there. Nothing marks the entry as already spent on
 * a tab.
 *
 * The stray field is a relation picker, which is meaningless for children (you
 * do not choose a company's vacancies from a dropdown) and which renders a red
 * "Unexpected value" box per row: the REST layer returns relation columns as
 * scalar ids, and the preview layer only accepts objects.
 *
 * Applying this leaves the tab intact, because the tab is derived from the
 * relation and not from the form field.
 *
 * A literal `true`, not the always-true JSON Logic rule, and the difference is
 * not cosmetic. `hidden` is a `ConditionRule` — `JsonLogicRule | boolean` — so
 * both typecheck, but they are read in two different places.
 *
 * The layout resolver (`buildField` in `@rebasepro/app`) asks `isHidden` about
 * the *raw* property, before there is an entity to evaluate a rule against, and
 * `isHidden` honours only the literal. Given `{ "==": [1, 1] }` it answers "not
 * hidden", keeps the field's slot on the form grid, and leaves a hole there once
 * `PropertyFieldBinding` — which does resolve conditions, and so does see the
 * rule — renders nothing into it. A `true` is understood by both, so the slot is
 * never allocated in the first place.
 *
 * Remove every use of this once rebase stops rendering child collections as form
 * inputs; it is a workaround, not a design choice.
 */
export const HIDDEN_FROM_FORM: PropertyConditions = { hidden: true };
